module.exports = __webpack_public_path__ + "media/honey-icons/icon-call-0a816de2.svg";